import { CarretLeft } from "../../Assets/SvgIcons";
import { useGetSuggestedQuery } from "../../../redux/reducers/apiSlice";
import { Tabs } from "../../Components/Tabs/Tabs";
import { People } from "../../Components/Tabs/People/People";
import {
  labelStyle,
  dividerStyle,
  customTabsSpacing,
} from "../../Components/SuggestedForYou/styles";
import { PageContainer, SuggestionsCard, CardHeader, TabContainer } from "./styles";
import { Organizations } from "../../Components/Tabs/Organizations/Organizations";
import { useNavigate } from "react-router-dom";

const ViewAllSuggestions = () => {
  const {
    data: suggested,
    isLoading: loadingSuggested,
    isError,
  } = useGetSuggestedQuery(undefined, {
    maxRetries: 0,
    refetchOnMountOrArgChange: true,
  });

  const navigate = useNavigate();

  return (
    <PageContainer>
      <SuggestionsCard>
        <CardHeader>
          <button
            type="button"
            className="nav-btn"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              navigate(-1);
            }}
            aria-label="Go back"
          >
            <CarretLeft />
          </button>
          <h2 data-cy="cypress-suggested-for-you-text">Suggested for you</h2>
        </CardHeader>
        {isError && (
          <p style={{ padding: "8px 0", color: "#666", fontSize: "14px" }}>
            Unable to load suggestions. Please try again later.
          </p>
        )}
        <TabContainer>
        <Tabs<"People" | "Organizations">
          customTabLabelStyle={labelStyle}
          customDividerStyle={dividerStyle}
          customTabsSpacing={customTabsSpacing}
          defaultSelectedTab={"People"}
          tabs={[
            {
              label: "People",
              component: (
                <People
                  loading={loadingSuggested}
                  people={suggested?.users ?? []}
                />
              ),
            },
            {
              label: "Organizations",
              component: (
                <Organizations
                  loading={loadingSuggested}
                  // @ts-ignore
                  organizations={suggested?.organizations ?? []}
                />
              ),
            },
          ]}
        />
        </TabContainer>
      </SuggestionsCard>
    </PageContainer>
  );
};

export default ViewAllSuggestions;
